export default () => {
  const ultimoUpdate = new Date("02/06/2023");
  const hoy = new Date();

  const diferencia = hoy.getTime() - ultimoUpdate.getTime();
  const dias = Math.floor(diferencia / (1000 * 3600 * 24));

  return dias;
};
